import { stats, faqs } from '@/mocks/comics';

export default function StatsAndFAQ() {
  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((f) => ({
      '@type': 'Question',
      name: f.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: f.answer,
      },
    })),
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
      />

      <section className="w-full py-16 md:py-24 bg-foreground-950">
        <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-10">
            {stats.map((stat) => (
              <div key={stat.label} className="text-center">
                <p className="text-3xl md:text-5xl font-heading font-bold text-background-50">
                  {stat.value}
                </p>
                <p className="text-xs md:text-sm text-foreground-400 mt-2">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="w-full py-16 md:py-24 bg-background-100">
        <div className="w-full max-w-4xl mx-auto px-4 md:px-6">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
              常见问题
            </h2>
            <p className="text-sm md:text-base text-foreground-600 mt-2">
              关于韩国漫画网，你想知道的都在这里
            </p>
          </div>

          <div className="flex flex-col gap-3">
            {faqs.map((faq, index) => (
              <details key={index} className="group rounded-xl bg-background-50 border border-background-200/70 overflow-hidden">
                <summary className="flex items-center justify-between p-5 md:p-6 cursor-pointer text-sm md:text-base font-medium text-foreground-900 hover:text-primary-500 transition-colors">
                  {faq.question}
                  <i className="ri-arrow-down-s-line text-lg transition-transform duration-200 group-open:rotate-180" />
                </summary>
                <div className="px-5 md:px-6 pb-5 md:pb-6 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </div>
              </details>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}